<div class="kt-portlet__body" *ngIf="events.length === 0">

    <!--begin::Section-->
    <div class="kt-section">
        <div class="kt-section__content">
            <div class="kt-demo">
                <div class="kt-demo__preview">
                    <div class="alert alert-warning" role="alert">
                        <div class="alert-text">
                            <h4 class="alert-heading">Aktif etkinlik bulunamadı!</h4>
                            <hr>
                            <p>Şu anda aktif bir etkinlik bulunmamaktadır. Etkinlik eklendiği zaman bu sayfadan
                                etkinlikleri listeleyip başvuru yapabilirsin. Etkinlik oluşturulduğu zaman mail ile bir
                                bildirim alacaksın!</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--end::Section-->
</div>
<div class="row">
    <div class="col-xl-6" *ngFor="let event of events;">

        <!--begin:: Widgets/Blog-->
        <div class="kt-portlet kt-portlet--height-fluid kt-widget19">
            <div class="kt-portlet__body kt-portlet__body--fit kt-portlet__body--unfill">
                <div class="kt-widget19__pic kt-portlet-fit--top kt-portlet-fit--sides" style="min-height: 250px;"
                    [ngStyle]="{'background-image': 'url(' + assetsPath + event.image + ')'}">
                    <h3 class="kt-widget19__title kt-font-light">
                        {{event.name}}
                    </h3>
                    <div class="kt-widget19__shadow"></div>
                    <div class="kt-widget19__labels">
                        <button class="btn btn-label-light-o2 btn-bold ">{{event.eventCategoryName}}</button>
                    </div>
                </div>
            </div>
            <div class="kt-portlet__body">
                <div class="kt-widget19__wrapper">
                    <div class="kt-widget19__content">
                        <div class="kt-widget__item" style="float: left;">
                            <div class="kt-widget__label" style="float: right;">
                                <span class="btn btn-label-brand btn-sm btn-bold btn-upper"><span
                                        style="color:#000">BAŞLANGIÇ TARİHİ:</span> {{event.startDate}}</span>
                            </div>
                        </div>
                        <div class="kt-widget__item" style="clear: both;float:left;">
                            <div class="kt-widget__label" style="float: right;">
                                <span class="btn btn-label-danger btn-sm btn-bold btn-upper"><span
                                        style="color:#000">BİTİŞ TARİHİ:</span> {{event.endDate}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="kt-widget19__text">
                        Mekan / Lokasyon: <strong>{{event.location}}</strong><br><br>
                        {{event.description}}
                    </div>
                </div>
                <div class="kt-widget19__action">
                    <!-- <a href="#" class="btn btn-sm btn-label-brand btn-bold">Read More...</a> -->
                    <button type="button" [routerLink]="['/apply-for-event/'+event.id]"
                        class="btn btn-sm btn-label-success btn-bold">BAŞVUR</button>
                </div>
            </div>
        </div>

        <!--end:: Widgets/Blog-->
    </div>
</div>